<ng-container *ngIf="showElement">
  <ng-container *ngIf="length(filterTransitions(currentItemState.transitions,'right')) === 1">
    <ion-item-options side="start" (ionSwipe)="swipe({itemTypeName: itemTypeName
    , singleItem: singleItem
    , itemIds: itemIds
    , itemStateName: itemStateName
    , slide: slide
    , transition_name:transition.name})"
      *ngFor="let transition of filterTransitions(currentItemState.transitions,'right');">
      <ion-item-option color="success" expandable="true" (click)="swipe({itemTypeName: itemTypeName
      , singleItem: singleItem
      , itemIds: itemIds
      , itemStateName: itemStateName
      , slide: slide
      , transition_name:transition.name})">
        <ion-icon [ios]="'checkmark-outline'" [md]="'checkmark-sharp'" name="checkmark-outline"></ion-icon>
        {{transition.name }}
      </ion-item-option>
    </ion-item-options>
  </ng-container>
  <ng-container *ngIf="length(filterTransitions(currentItemState.transitions,'right')) > 1">
    <ion-item-options side="start">
      <ion-item-option color="success" expandable="true" (click)="swipe({itemTypeName: itemTypeName
      , singleItem: singleItem
      , itemIds: itemIds
      , itemStateName: itemStateName
      , slide: slide
      , transition_name:transition.name})"
        *ngFor="let transition of filterTransitions(currentItemState.transitions,'right');">
        <ion-icon [ios]="'checkmark-outline'" [md]="'checkmark-sharp'" name="checkmark-outline"></ion-icon>
        {{transition.name }}
      </ion-item-option>
    </ion-item-options>
  </ng-container>
  <ng-container *ngIf="length(filterTransitions(currentItemState.transitions,'left')) === 1">
    <ion-item-options side="end" (ionSwipe)="swipe({itemTypeName: itemTypeName
  , singleItem: singleItem
  , itemIds: itemIds
  , itemStateName: itemStateName
  , slide: slide
  , transition_name:transition.name})"
      *ngFor="let transition of filterTransitions(currentItemState.transitions,'left');">
      <ion-item-option color="danger" expandable="true" (click)="swipe({itemTypeName: itemTypeName
    , singleItem: singleItem
    , itemIds: itemIds
    , itemStateName: itemStateName
    , slide: slide
    , transition_name:transition.name})">
        {{ transition.name }}
        <ion-icon [ios]="'close-outline'" [md]="'close-sharp'" name="close-outline"></ion-icon>
      </ion-item-option>
    </ion-item-options>
  </ng-container>
  <ng-container *ngIf="length(filterTransitions(currentItemState.transitions,'left')) > 1">
    <ion-item-options side="end">
      <ion-item-option color="danger" expandable="true" (click)="swipe({itemTypeName: itemTypeName
    , singleItem: singleItem
    , itemIds: itemIds
    , itemStateName: itemStateName
    , slide: slide
    , transition_name:transition.name})"
        *ngFor="let transition of filterTransitions(currentItemState.transitions,'left');">
        {{ transition.name }}
        <ion-icon [ios]="'close-outline'" [md]="'close-sharp'" name="close-outline"></ion-icon>
      </ion-item-option>
    </ion-item-options>
  </ng-container>
</ng-container>
